import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Field} from 'src/app/shared/detail/detail.service';
import {DialogService} from 'src/app/shared/dialog/dialog.service';
import {
  EditUcetniObdobiDto,
  UcetniObdobiDto,
  UcetniObdobiEmitData
} from 'src/app/ucetni-obdobi-data/models/UcetniObdobiDtos';
import {UcetniObdobiDataService} from 'src/app/ucetni-obdobi-data/ucetni-obdobi-data.service';
import {CreatJsonService} from '../shared/cml-forms/create-json.service';
import {MasterDetailHub} from "../shared/master-detail/master-detail-hub.service";
import {MapperDefaultValues, MapperKeys} from "../shared/crud/abstractions/base-crud";
import {NastaveniPap} from "../nastaveni-pap-data/models/NastaveniPapDto";
import {NastaveniPapDataService} from "../nastaveni-pap-data/nastaveni-pap-data.service";

const COLUMNS: Field[] = [
  { name: "kod", type: "string", title: "Kód", required: true, maxLength: 6, minLength: 4},
  { name: "kodS", type: "string", title: "KódS", maxLength: 2},
  { name: "od", type: "date", title: "Od", required: true },
  { name: "do", type: "date", title: "Do", required: true },
  { name: "popis", type: "string", title: "Popis", maxLength: 255 },
];

const EDIT_COLUMNS: Field[] = [
  { name: "kodS", type: "string", title: "KódS", maxLength: 2},
  { name: "popis", type: "string", title: "Popis", maxLength: 255,},
  { name: "sestavujePAP", type: "boolean", title: "Sestavuje PAP", required: true}
];



@Component({
    selector: 'cml-ucetni-obdobi',
    templateUrl: './ucetni-obdobi.component.html',
    styleUrls: ['../ucetni-jednotka/ucetni-jednotka-detail.component/ucetni-jednotka-detail.component.scss'],
    standalone: false
})
export class UcetniObdobiComponent implements OnInit {
  @Output() ucetniObdobiDataEvent: EventEmitter<UcetniObdobiEmitData> = new EventEmitter<UcetniObdobiEmitData>();
  userResponse: any

  entityId: string;
  dataSource: Array<UcetniObdobiDto> = [];
  enabledPapUcetniObdobi: NastaveniPap[] = [];
  tableColumns: Field[]=
    [
      {name:'kod',title: 'Kód',type:""},
      {name:'od',title: 'Od',type:"date"},
      {name:'do',title: 'Do',type:"date"},
      {name:'popis',title: 'Popis',type:""},
    ];
  displayedColumns: string[] = ['kod', 'od', 'do','popis', 'dokladRada', 'uctovyRozvrh', 'vypocetVykazu','edit','akce'];
  panelOpenState = false;
  columns = COLUMNS;
  editColumns = EDIT_COLUMNS

  async ngOnInit() {
    await this.initialiseState();
  }

  async initialiseState() {
    let mapped = this.dataService.setMapper(
      [
        {key: MapperKeys.KodUj, value: this.entityId},
        {key: MapperKeys.MaxResultCount, value: MapperDefaultValues.MaxResultCount}
      ])
    this.dataSource = await this.dataService.getAll({params: mapped});
    mapped = this.dataService.setMapper({key: MapperKeys.KodUj, value: this.entityId})
    this.enabledPapUcetniObdobi = await this.nastaveniPapDataService.getAll({params:mapped})
    this.ucetniObdobiDataEvent.emit({ucetniObdobi: this.dataSource,fields: this.tableColumns})
  }

  constructor(private dataService: UcetniObdobiDataService, private nastaveniPapDataService: NastaveniPapDataService, private route: ActivatedRoute,
    public router: Router, private dialogService: DialogService, private createJson: CreatJsonService,
              private masterDetailHub: MasterDetailHub) {
    route.params.subscribe(params => {
      if (this.dataService) {
        this.entityId = params['id'];
        this.initialiseState()
      }
    });
    this.entityId = this.route.snapshot.params['id'];
  }

  navigateToDokladovaRada(kod: string) {
    this.router.navigate([this.router.url + '/dokladova-rada', kod]);
  }

  navigateToUctovyRozvrh(element: any) {
    this.router.navigate([this.router.url + '/uctovy-rozvrh', element.kod]);
  }

  navigateToVypocetVykazu(element: any)
  {
    this.router.navigate([this.router.url + '/vypocet-vykazu', element.kod])
  }

  async delete(i: number) {
    const conf = await this.dialogService.confirm({title: "Potvrzení", detail: "Chcete opravdu smazat toto účetní období?"});
    if (!conf) return;
    try {
      const mapper = this.dataService.setMapper([
        {key: MapperKeys.KodUj,value: this.entityId},
        {key: MapperKeys.KodUo, value: this.dataSource[i].kod }
      ])
      await this.dataService.delete(mapper);
      await this.initialiseState();
    }
    catch (e) {
      await this.dialogService.handleError(e)
    }
  }
  getPrefilledColumns(baseColumns: Field[] = [], userResponse: any = undefined)
  {
    let copyColumns: Field[] = [];
    baseColumns.forEach(x => {copyColumns.push(Object.assign({},x))});
    copyColumns.forEach( x => x.default = userResponse[x.name])
    return copyColumns;
  }
  async newUcetniObdobiModal(prefill: boolean = false)
  {
    if(prefill)
    {
      let clonedCols = this.getPrefilledColumns(this.columns,this.userResponse.value)
      this.userResponse = await this.dialogService.form({title: "Nové účetní období", detail: clonedCols, validation: true, component: this as any, useDateValid: true});
    }
    else
    {
      this.userResponse = await this.dialogService.form({title: "Nové účetní období", detail: this.columns, validation: true, component: this as any, useDateValid: true})
    }
    if(this.userResponse)
      await this.new()
  }

  async new() {
      const json = JSON.parse(this.createJson.createJsonFromControl(this.userResponse, this.createJson.getAttributes(this.columns), this.columns));
      try {
        const mapper = this.dataService.setMapper({key: MapperKeys.KodUj, value: this.entityId})
        await this.dataService.create(mapper, json);
        await this.initialiseState();
      } catch (e)
      {
        await this.newUcetniObdobiModal(true)
      }
  }

  async edit(entity: number) {
    const dataElement: UcetniObdobiDto = this.dataSource[entity]
    let apiUORes: any;

    let mapped = this.dataService.setMapper(
    [
      {key: MapperKeys.KodUj, value: dataElement.kodUj},
      {key: MapperKeys.KodUo, value: dataElement.kod}
    ])

    apiUORes = await this.dataService.get(mapped);

    const foundPAP = this.enabledPapUcetniObdobi.find(x => x.kodUo == apiUORes.kod)?.sestavujePAP
    apiUORes.sestavujePAP = foundPAP ?? false //kdyz neexistuje, prihodime false defaultne
    const detail = this.getPrefilledColumns(this.editColumns, apiUORes)

    const userRes = await this.dialogService.form({title:"Editace účetního období", detail})
    if(!userRes) return

    const parsedUo: EditUcetniObdobiDto = {
      kodS: userRes.value.kodS,
      popis: userRes.value.popis,
      mesice: apiUORes.ucetniObdobiMesice,
      kvartaly: apiUORes.ucetniObdobiKvartaly,
    }
    const parsedPap: NastaveniPap = {
      kodUj: this.entityId,
      kodUo: apiUORes.kod,
      sestavujePAP: userRes.value.sestavujePAP
    }
    await this.editApiCallHandler(mapped,parsedUo,parsedPap)
  }

  async editApiCallHandler(mapped: Map<MapperKeys,any>, parsedUo: EditUcetniObdobiDto, parsedPap: NastaveniPap)
  {
    const existNastaveni = !!this.enabledPapUcetniObdobi.find(x => {return x.kodUo == parsedPap.kodUo})
    const nastaveniCall = existNastaveni ? this.nastaveniPapDataService.edit('', parsedPap) : this.nastaveniPapDataService.create('', parsedPap)
    await this.dataService.edit(mapped, parsedUo);
    await nastaveniCall;
    await this.initialiseState();
  }
  async doValidation(form: FormGroup, columns: Field[]): Promise<boolean> {
    const mapped = this.dataService.setMapper([
        {key: MapperKeys.KodUj, value: this.entityId},
        {key: MapperKeys.MaxResultCount, value: MapperDefaultValues.MaxResultCount}])
    const res: any = await this.dataService.getAll({params:mapped});
    let flag = true;
    res.forEach((e: any) => {
      let isCollstion = ((form.value.od.toDate()) <= new Date(e.do)) && (new Date(e.od) <= (form.value.do.toDate()));
      flag = flag && !isCollstion;
    });
    return flag;
  }

  getErrorMessage(){
    return "Kolize datumu s jinými účetními obdobími.";
  }
}

